import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashboardRoutingModule} from './dashobard-routing.module';
import {
  ChartComponent,
  DashboardComponent,
  AdminDashboardComponent
} from './components';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {GoogleMapsModule} from '@angular/google-maps';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MandateModalComponent} from '../mandates/components';
import {MockDealCardService} from "./services";
import {NgMaterialModule} from "../ng-material/ng-material.module";
import {SharedModule} from "../shared/shared.module";


@NgModule({
  declarations: [
    ChartComponent,
    AdminDashboardComponent,
    DashboardComponent,
    MandateModalComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    DashboardRoutingModule,
    NgxChartsModule,
    GoogleMapsModule,
    FormsModule,
    ReactiveFormsModule,
    NgMaterialModule
  ],
  exports: [

  ],
  providers: [
    MockDealCardService
  ]
})
export class DashboardModule {
}
